/**
 * AJ Lead Capture — GA4 event firing (consent-gated).
 *
 * Fires gtag() events using the site's existing GA4 tag. Gated behind Google
 * Consent Mode (analytics_storage) read from the GTM dataLayer: if consent is
 * explicitly denied, events are suppressed. With no consent signal present
 * (no banner), events fire. If window.gtag is absent, events are dropped
 * silently.
 *
 * @module analytics
 */

/**
 * Whether analytics consent is granted per Google Consent Mode.
 *
 * Scans the dataLayer for the most recent consent default/update. Defaults to
 * granted when no signal exists (americajosh.com has no consent banner today).
 *
 * @returns {boolean} Whether GA4 events may fire.
 */
export function consentGranted() {
  const dl = window.dataLayer;
  if (!Array.isArray(dl)) {
    return true;
  }
  let granted = true;
  dl.forEach((entry) => {
    if (entry && (entry[0] === 'consent') && (entry[1] === 'default' || entry[1] === 'update')) {
      const state = entry[2] && entry[2].analytics_storage;
      if (state === 'denied') {
        granted = false;
      } else if (state === 'granted') {
        granted = true;
      }
    }
  });
  return granted;
}

/**
 * Fire a GA4 event (no-op if gtag missing or consent denied).
 *
 * @param {string} event  Event name.
 * @param {Object} params Event params.
 * @returns {void}
 */
export function ga(event, params) {
  if (typeof window.gtag !== 'function' || !consentGranted()) {
    return;
  }
  window.gtag('event', event, params);
}
